import {
  SET_FEEDBACKS,
  SET_FEEDBACK_FILTERS,
  SET_FEEDBACK,
  SET_FEEDBACK_ERRORS,
  SET_FEEDBACK_FIELD,
  SET_FEEDBACK_MANAGERS,
  SET_FEEDBACK_ORDERS,
  APPEND_SUBFEEDBACK,
  REPLACE_SUBFEEDBACK,
  SET_SUBFEEDBACK_FIELD,
} from '@/store/mutation_types'

export default {
  [SET_FEEDBACKS](state, value) {
    state.feedbacks = value
  },
  setFeedbackFilters(state, filters) {
    state.feedbackFilters = filters
  },
  [SET_FEEDBACK_FILTERS](state, filters) {
    state.feedbackFilters = filters
  },
  [SET_FEEDBACK](state, value) {
    state.feedback = value
  },
  [SET_FEEDBACK_ERRORS](state, serviceErrors) {
    state.feedbackErrors = serviceErrors
  },
  [SET_FEEDBACK_FIELD](state, obj) {
    if (state.feedback) {
      if (obj.value === '') {
        obj.value = null
      }

      state.feedback[obj.key] = obj.value
    }
  },
  [SET_FEEDBACK_MANAGERS](state, value) {
    state.feedbackManagers = value
  },
  [SET_FEEDBACK_ORDERS](state, value) {
    state.feedbackOrders = value
  },
  [APPEND_SUBFEEDBACK](state, subfeedback) {
    state.feedback.order_subreviews.push(subfeedback)
  },
  [REPLACE_SUBFEEDBACK](state, { index, subfeedback }) {
    if (state.feedback.order_subreviews[index] !== undefined) {
      state.feedback.order_subreviews[index] = subfeedback
    }
  },
  [SET_SUBFEEDBACK_FIELD](state, { index, key, value }) {
    const subfeedback = state.feedback.order_subreviews[index]
    if (state.feedback && subfeedback !== undefined) {
      if (value === '') {
        value = null
      }

      subfeedback[key] = value
    }
  },
  setOrderByHash(state, value) {
    state.orderByHash = value
  },
  setFeedbackHistory(state, value) {
    state.feedbackHistory = value
  },
}
